/**
 * Week calculation utilities for timeline components
 */

import {
  addDays,
  formatWeekDateLabel,
  startOfWeek
} from "./dateUtils";

export function getDefaultWeekCount() { return 26 };

export function getStartOfWeek(date: Date): Date {
  return startOfWeek(date);
}

/**
 * Represents a week column in the timeline
 */
export interface WeekColumn {
  start: Date;
  end: Date;
  label: string;
}

export function isoKey(week: WeekColumn): string {
  return week.start.toISOString();
}

export function buildWeekColumnForDate(date: Date): WeekColumn {
  const weekStart = getStartOfWeek(date);
  return {
    start: weekStart,
    end: addDays(weekStart, 6),
    label: formatWeekDateLabel(weekStart),
  };
}

/**
 * Compute week columns from a date range
 * Ensures at least DEFAULT_WEEK_COUNT weeks are included
 */
export function computeWeekColumns(
  startDate: Date,
  numWeeks: number
): WeekColumn[] {
  const start = getStartOfWeek(startDate);

  const weeks: WeekColumn[] = [];

  for (let i = 0; i < numWeeks; i++) {
    const weekStart = addDays(start, i * 7);
    const weekEnd = addDays(weekStart, 6);
    weeks.push({
      start: weekStart,
      end: weekEnd,
      label: formatWeekDateLabel(weekStart),
    });
  }

  return weeks;
}

export function computeNumWeeks(startDate: Date, endDate: Date): number {
  return Math.floor((endDate.getTime() - startDate.getTime()) / (7 * 24 * 60 * 60 * 1000));
}